"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveInfoRequest = void 0;
var SaveInfoRequest = /** @class */ (function () {
    function SaveInfoRequest() {
    }
    return SaveInfoRequest;
}());
exports.SaveInfoRequest = SaveInfoRequest;
;
//# sourceMappingURL=saveInfo.request.js.map